// extracted by mini-css-extract-plugin
export var documentList = "document-list-module--document-list--2QNqS";
export var documentListItem = "document-list-module--document-list-item--2AcDg";
export var documentListLink = "document-list-module--document-list-link--3RiSS";
export var documentListArrow = "document-list-module--document-list-arrow--2zvdX";
export var documentListTitle = "document-list-module--document-list-title--1nNe9";
export var documentListDate = "document-list-module--document-list-date--2HkN2";